module.exports = __webpack_public_path__ + "e3e2679a.png";